__turbopack_context__.v({
  "big": "Vnpk7q_big",
  "video-iframe": "Vnpk7q_video-iframe",
});
